import { quickTags } from "@/mocks/gossip";

export default function Hero() {
  const go = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-accent-200/40 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-primary-200/40 blur-3xl"></div>

      <div className="mx-auto w-full max-w-7xl px-4 pb-16 pt-28 md:px-6 md:pt-36">
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-3xl">
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
                </span>
                今晚 22:00 瓜田晚报已上线
              </span>
              <span className="rounded-full bg-background-200/80 px-3 py-1 text-xs font-medium text-foreground-600">收尾盘点 · 全瓜复盘</span>
            </div>
            <h1 className="serif-title mt-6 text-4xl font-black leading-tight text-foreground-950 md:text-6xl">
              今晚瓜田，
              <br className="hidden md:block" />
              一篇<span className="text-primary-600">看完</span>。
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
              吃瓜今日晚间汇总带你复盘今天一整天的瓜田战况。从早到晚全部瓜、收尾盘点、争议后续一次讲清，错过直播也能快速补完今日全部瓜。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#recap"
                onClick={(e) => go(e, "#recap")}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
              >
                直达全瓜复盘
                <i className="ri-arrow-down-line"></i>
              </a>
              <a
                href="#hot"
                onClick={(e) => go(e, "#hot")}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-foreground-200 bg-background-50 px-7 py-3 text-sm font-semibold text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
              >
                先看热议榜 Top 6
              </a>
            </div>
          </div>

          <div className="hidden flex-col gap-3 lg:flex">
            <div className="rounded-2xl border border-background-200 bg-background-50 px-6 py-5 shadow-card">
              <div className="flex items-center gap-6">
                <div>
                  <p className="text-3xl font-black text-primary-600">24</p>
                  <p className="text-xs text-foreground-500">今日收录瓜</p>
                </div>
                <div className="h-10 w-px bg-background-200"></div>
                <div>
                  <p className="text-3xl font-black text-accent-600">6</p>
                  <p className="text-xs text-foreground-500">争议跟进</p>
                </div>
                <div className="h-10 w-px bg-background-200"></div>
                <div>
                  <p className="text-3xl font-black text-secondary-600">3</p>
                  <p className="text-xs text-foreground-500">正向惊喜</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-2 border-t border-background-200 pt-6">
          <span className="mr-1 text-sm font-semibold text-foreground-800">今日高频热词</span>
          {quickTags.map((t) => (
            <span key={t} className="cursor-pointer rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs font-medium text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700">
              # {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}